module.exports = __webpack_public_path__ + "img/tag_mix.eaa5d631.svg";